module.exports = __webpack_public_path__ + "img/start_scratch.48743655.png";